import "core-js/features/promise";
import "regenerator-runtime/runtime";

import SmoothScroll from 'smooth-scroll';

import './jquery-global';
import "jquery-form";

import "@fancyapps/fancybox";
import "@fancyapps/fancybox/dist/jquery.fancybox.min.css";

import "slick-carousel/slick/slick.css";
import "slick-carousel/slick/slick-theme.css";
import "slick-carousel/slick/slick.min.js";
import "./slick-custom.css";

import "./style.css";
import "./mobile.css";
import "./mobile-images.css";
import "./handleiding.css";

import $ from 'jquery';

import { initMailingPopup } from 'pages/mailing-popup';
import { initAanmeldenformulierPage, initContactPage, initOverstappenForm} from 'pages/contact';
import { initInschrijvenPage } from 'pages/inschrijven';
import { initHandleiding } from 'pages/handleiding';
import { initReviews } from 'pages/reviews';

(function(h,o,t,j,a,r){
	h.hj=h.hj||function(){(h.hj.q=h.hj.q||[]).push(arguments)};
	h._hjSettings={hjid:2003998,hjsv:6};
	a=o.getElementsByTagName('head')[0];
	r=o.createElement('script');r.async=1;
	r.src=t+h._hjSettings.hjid+j+h._hjSettings.hjsv;
	a.appendChild(r);
})(window,document,'https://static.hotjar.com/c/hotjar-','.js?sv=');

function initTestimonials() {
	$(".reviewContent").click(function(){
		$(this).children(".reviewText").toggleClass('line-clamp3');
		$(this).children("i").toggleClass('spin');
	});

	$('.testimonialCarousel').slick({
		infinite: true,
		dots: true,
		autoplay: true,
		autoplaySpeed: 5000
	});
}

function initFeatureSliderHomepage() {
	$('.featuresContainer').slick({
		infinite: true,
		dots: true,
		slidesToShow: 3,
		responsive: [{
			breakpoint: 800,
			settings: {
				slidesToShow: 1,
				centerMode: true,
				slidesToScroll: 1
			}
		}]
	});
}

function initTestimonialSliderHomepage() {
	$('.testimonialsContainer ').slick({
		infinite: true,
		dots: true,
		slidesToShow: 3,
		responsive: [{
			breakpoint: 800,
			settings: {
				slidesToShow: 1,
				centerMode: false,
				slidesToScroll: 1
			}
		}]
	});
}



function initHomeCarousel() {
	$('.homeCarousel').slick({
		infinite: true,
		dots: true,
		autoplay: true,
		autoplaySpeed: 5000
	});
	$('.homeCarousel').show();
	$('.slick-cloned').removeAttr('data-fancybox');
}

function initSmoothScroll() {
	const opts = {
		header: '#header',
		offset: 40,
		speed: 500,
		speedAsDuration: true,
	};
	new SmoothScroll('a[href*="#"]', opts);
}

function initFancyBox() {
	$(".fancybox").fancybox({
		openEffect  : 'none',
		closeEffect : 'none',
		transitionEffect: "slide",
		helpers : {
			overlay : {
				locked : false,
			}
		}
	});
}

function initScroll() {
	window.onscroll = function() {
		const header = document.getElementById("header");
		if (document.body.scrollTop > 70
				|| document.documentElement.scrollTop > 70 ) {
			header.classList.add("scroll");
		} else {
			header.classList.remove("scroll");
		}
	}
}

function initNoteExpand() {
	$(".note > h1").on("click", function() {
        $(this).next(".noteHide").slideToggle(200);
        $(this).children(".expand").toggleClass('active');
    });
}

function hideMenu() {
	$(".mainMenuItem.withSubmenu > a, #mobileNavButton").removeClass("active");
	$("#header").removeClass("active");
	$(".subMenu").slideUp(100);
}

function initNavLinks() {
	$("#mobileNavButton").click(function(){
		$(this).next("#nav").slideToggle(200);
		$(this).children('i').toggleClass('fa-bars fa-times');
	});

	$(".mainMenuItem.withSubmenu > a, #mobileNavButton").on("click", function(e) {
		e.stopPropagation();
		var clickedWasActive = $(this).hasClass("active");
		hideMenu();
		if (clickedWasActive) {
			return;
		}
		$(this).addClass("active");
		$("#header").addClass("active");
		var $target = $(this).next(".subMenu");
		$target.slideDown(200);
	});

	$(document).on("click", function(event) {
		if ($(event.target).closest(".subMenu").length === 0) {
			hideMenu();
		}
	});
}

function initFeatures() {
	$(".features .sectionBlock li h2").click(function(){
		$(this).next("p").slideToggle(200);
		$(this).parent().toggleClass("active");
		$(this).children("i.toggleIcon").toggleClass("fa-plus fa-minus");
	});
}

const digiPages = {
	initContactPage,
	initAanmeldenformulierPage,
	initInschrijvenPage,
	initHandleiding,
	initReviews,
}

function initCustomPages() {
	const init = $("body").attr("digi-js-init");
	if (! init) {
		return;
	}
	if (typeof(digiPages[init]) !== 'function') {
		throw new Error("Not a function: digiPages." + init);
	}
	digiPages[init]();
}

function initShareButtons() {
	$(".shareButton").click(function(){
		$(this).next(".shareButtons").toggleClass('visible');
	});
}

function initExtraMenuItems() {
	$(".showExtraMenuItems").click(function(){
		$(this).next(".extraMenuItmes").slideToggle(200);
		$(this).toggleClass('link');
	});
}

function initExtraInfo() {
	$(".extraInfoIcon").click(function(){
		$(this).next(".extraInfo").slideToggle(200);
	});
}


$(function() {
	initFancyBox();
	initSmoothScroll();
	initTestimonials();
	initScroll();
	initMailingPopup();
	initNoteExpand();
	initNavLinks();
	initHomeCarousel();
	initFeatures();
	initCustomPages();
	initShareButtons();
	initFeatureSliderHomepage();
	initTestimonialSliderHomepage();
	initOverstappenForm();
	initExtraMenuItems();
	initExtraInfo();
});


